var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"card-height-300"},[_c('p',{staticClass:"inverter-item"},[_vm._v("\n    "+_vm._s(_vm.item.name)+":\n    "),_c('strong',[_vm._v(_vm._s(_vm.item.gen)+" kWh")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }